// extracted by mini-css-extract-plugin
export var inlineLink = "_ao-0";
export var inlineLinkButton = "_ao-1";